import { AsyncActionHandler } from 'action-handler';

export default new AsyncActionHandler({
  name: 'fetch_device_info',
  defaultState: {
    deviceInfo: {}
  },
  handler() {
    return async () => ({
      deviceInfo: await window.__webview_comms__.get('device-info')
    });
  },
  reduce(state, actionData) {
    return actionData;
  }
});
